<script lang="ts">
    import { onMount } from 'svelte'
    import { MGMemberEntity, MGMembersPublicStatusEnum, MGMPublicStatusFriendly } from '../../modules/toolsApi/mgmembers/mgmember.entity'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import ZContainerRow from '../_common/z/z-container-row.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZinputEmpty from '../_common/z/zinput-empty.svelte'
    import ZinputTitle from '../_common/z/zinput-title.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import dayjs from 'dayjs'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'

    const segments: { label: string; value: string }[] = [
        { value: 'Clínica estética', label: 'Clínica estética' },
        { value: 'Barbearia', label: 'Barbearia' },
        { value: 'Salão de beleza', label: 'Salão de beleza' },
        { value: 'Estúdio de tatuagem', label: 'Estúdio de tatuagem' },
        { value: 'Consultório', label: 'Consultório' },
        { value: 'outro', label: 'Outro' },
    ]

    let pixKey: string = window.store.user.pixKey

    let show = false

    let member: MGMemberEntity = new MGMemberEntity()
    function newMember() {
        member = new MGMemberEntity()
        member.managerId = window.store.company.managerId
        member.userId = window.store.user.userId
    }

    let shareLink: string = ''
    function generateShareLink() {
        shareLink = location.protocol + '//' + location.host + '/public/mgm?mid=' + window.store.company.managerId + '&uid=' + window.store.token.userId
    }

    async function send() {
        try {
            show = true
            if (window.store.user.pixKey !== pixKey) {
                await window.api.users.users.update(window.store.user.userId, { pixKey })
                window.store.user.pixKey = pixKey
            }
            await window.api.tools.mgmMembers.create(member)
            await loadMembers()
            newMember()
            window.alert('Indicação enviada com sucesso!')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let members: MGMemberEntity[] = []
    async function loadMembers() {
        const from = dayjs(new Date()).add(-91, 'day').format('YYYY-MM-DD')
        members = await window.api.tools.mgmMembers.getAll({ from })
        loadGrid()
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Indicados'
        grid.showActs = false
        grid.subtitle = 'Indicados dos últimos 90 dias'
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'WhatsApp', type: GridColTypeEnum.phone }))
        // grid.cols.push(new GridCol({ content: 'Segmento' }))
        grid.cols.push(new GridCol({ content: 'Status' }))
        // grid lines
        for (const item of members) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.indicatedName })
            line.slots.push({ content: item.indicatedPhone })
            // line.slots.push({ content: item.indicatedSegment })
            line.slots.push({ content: MGMPublicStatusFriendly[MGMembersPublicStatusEnum[item.publicStatus]] })
            grid.lines.push(line)
        }
    }

    onMount(async () => {
        generateShareLink()
        newMember()
        await loadMembers()
    })
</script>

<LoadSpinner {show}></LoadSpinner>

<div class="root-content p-3">
    <div class="fs-2">Indique e ganhe!</div>
    <p>Receba <b>R$100,00</b> para cada indicado que contratar nossa plataforma.</p>
    {#if !window.store.company?.managerId}
        <div class="mt-5 text-center">
            A participação da empresa no programa de indicações não está ativo.<br />Não perca tempo, solicite agora ao suporte para ativar.
        </div>
    {:else}
        <ZContainer>
            <ZinputTitle label="Informe sua chave Pix para receber"></ZinputTitle>
            <Zinput size={4} label="Seu nome" disabled={true} value={window.store.user.userName}></Zinput>
            <Zinput size={4} label="Seu WhatsApp" disabled={true} value={window.store.user.phone}></Zinput>
            <Zinput size={4} label="Sua chave PIX" required={true} bind:value={pixKey}></Zinput>
            <ZinputTitle label="Informe os dados da pessoa indicada"></ZinputTitle>
            <Zinput size={4} label="Nome da pessoa indicada" bind:value={member.indicatedName} required={true}></Zinput>
            <Zinput size={4} label="WhatsApp" required={true} bind:value={member.indicatedPhone}></Zinput>
            <Zinput size={4} type="select" options={segments} label="Segmento" bind:value={member.indicatedSegment} required={true}></Zinput>
            <Zinput size={12} label="Comentários" bind:value={member.comments}></Zinput>
            <ZContainerRow>
                <ZinputEmpty total={null}></ZinputEmpty>
                <Zbutton color="green" label="Enviar indicação" on:click={send}></Zbutton>
            </ZContainerRow>
        </ZContainer>
        <div class="mt-5 h-full">
            <div>Link de compartilhamento</div>
            <div class="text-muted">Você também pode enviar um link para o indicado preencher. A indicação será registrada em seu nome.</div>
            <Zinput disabled={true} showCopy={true} value={shareLink}></Zinput>
        </div>
        {#if members.length > 0}
            <Zgrid class="mt-5" {grid}></Zgrid>
        {/if}

        <div class="text-muted mt-5 fs-6 pb-2">
            <div>Regras</div>
            <ul>
                <li>Indique clientes e ganhe um prêmio de R$100,00 para cada contrato assinado.</li>
                <li>Após a indicação o indicado deverá assinar o contrato em até 90 dias.</li>
                <li>Caso alguém seja indicado por mais de uma pessoa, a premiação será para o último a indicar.</li>
                <li>A indicação deve ser realizada por este formulário. Outros meios não são elegíveis para a premiação.</li>
                <li>Uma indicação pode ser rejeitada caso o indicado não esteja no perfil atendido pela Zandu.</li>
                <li>O indicado deverá confirmar que conhece você.</li>
                <li>Quando o indicado completar o período mínimo de 30 dias de permanência o pagamento será realizado.</li>
            </ul>
        </div>
    {/if}
</div>
